import { createMap, LayerTypeId, react } from "../../omnia"
import { TerramapContext } from "../context"
import { LayerType, SelectedLayerType } from "../types"

import FormGroupSelectNumber = react.FormGroupSelectNumber
import Checkbox = react.Checkbox

interface Props {
    layerTypes: LayerType[]
    layerType: SelectedLayerType
}

export function LayerTypeSelector({ layerTypes, layerType }: Props) {

    const { dispatch } = React.useContext(TerramapContext)

    const types = React.useMemo(() => createMap(layerTypes, t => t.typeId), [layerTypes])
    const options: [number, string][] = React.useMemo(() => layerTypes.map(t => [t.typeId, t.name]), [layerTypes])

    const hasDynamicScale = Boolean(layerType.typeId) && types.get(layerType.typeId)?.hasDynamicScale

    const selectTypeId = (typeId: LayerTypeId) => {
        dispatch({ type: "setLayerType", layerType: { typeId, dynamicScale: layerType.dynamicScale } })
    }

    const selectScale = (dynamicScale: boolean) => {
        dispatch({ type: "setLayerType", layerType: { typeId: layerType.typeId, dynamicScale } })
    }


    return <div className="section grey layer-types">

        <FormGroupSelectNumber
            options={options}
            value={layerType.typeId}
            setValue={selectTypeId}
            defaultLabel="(Layer type)"
        />

        {
            hasDynamicScale &&
            <Checkbox
                checked={layerType.dynamicScale}
                setChecked={selectScale}
            >
                Dynamic scale
            </Checkbox>
        }

    </div>
}
